import React from 'react';
import { Button, Tooltip } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useThemeStore } from '../theme/themeStore';

interface ThemeToggleProps {
  block?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ block = false }) => {
  const resolvedMode = useThemeStore((s) => s.resolvedMode);
  const toggleColorMode = useThemeStore((s) => s.toggleColorMode);
  const isDark = resolvedMode === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}>
      <Button
        type="text"
        block={block}
        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
        onClick={toggleColorMode}
        aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      />
    </Tooltip>
  );
};

export default ThemeToggle;
